// src/components/VisitaForm.jsx
import React, { useState, useEffect } from "react";
import "../assets/css/VisitaForm.css";

import { BASE } from '../services/api';
import { useToast } from '../context/ToastContext';

// ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ ÃƒÆ’Ã‚Âcones simples (evita dependÃƒÆ’Ã‚Âªncia extra) ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬
const Icon = () => null;
export default function VisitaForm() {
  const toast = useToast();
  const [successMessage, setSuccessMessage] = useState("");

  const [corretorInfo, setCorretorInfo] = useState({
    id: "", username: "", nome: "", telefone: "", instagram: "", descricao: "", email: "",
  });

  const [form, setForm] = useState({
    imovelId: "",
    dataVisita: new Date().toISOString().split("T")[0],
    parceiroExterno: "NAO",
    situacaoImovel: "CAPTACAO_61",
    revisita: "NAO",

    clienteNome: "",
    clienteTelefone: "",
    clienteEmail: "",

    proposta: "Talvez",
    papelVisita: "Interessado",

    enderecoExterno: "",
    parceiroNome: "",
    parceiroImobiliaria: "",

    clienteAssinanteNome: "",
    clienteAssinanteTelefone: "",
    clienteAssinanteEmail: "",

    assinatura: "",
    audioDescricaoClienteVisita: "",
    linkAudio: "",

    localizacao: 10, tamanho: 10, planta: 10, acabamento: 10,
    conservacao: 10, condominio: 10, preco: 10, notaGeral: 10,
    precoNota10: "",
  });

  const [pdfFile, setPdfFile]   = useState(null);
  const [loading, setLoading]   = useState(false);

  const [enderecoQuery, setEnderecoQuery]         = useState("");
  const [imoveisSugestoes, setImoveisSugestoes]   = useState([]);
  const [loadingImoveis, setLoadingImoveis]       = useState(false);
  const [showSugestoes, setShowSugestoes]         = useState(false);

  const [clientesDoCorretor, setClientesDoCorretor]           = useState([]);
  const [clientesSugestoes, setClientesSugestoes]             = useState([]);
  const [loadingClientes, setLoadingClientes]                 = useState(false);
  const [showClientesSugestoes, setShowClientesSugestoes]     = useState(false);
  const [clienteSelecionado, setClienteSelecionado]           = useState(null);
  const [clienteStatus, setClienteStatus]                     = useState("NOVO");
  const [leadsDoCorretor, setLeadsDoCorretor]                 = useState([]);
  const [leadsSugestoes, setLeadsSugestoes]                   = useState([]);
  const [loadingLeads, setLoadingLeads]                       = useState(false);

  const isImovelNaoCaptado = form.situacaoImovel === "IMOVEL_NAO_CAPTADO";

  const normText = (value) => String(value || "").trim().toLowerCase();
  const onlyDigits = (value) => String(value || "").replace(/\D/g, "");

  const formatarMoedaBR = (valor) => {
    const somenteNumeros = String(valor).replace(/\D/g, "");
  
    if (!somenteNumeros) return "";
  
    const numero = Number(somenteNumeros) / 100;
  
    return numero.toLocaleString("pt-BR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };
  
  const handlePrecoNota10Change = (e) => {
    const somenteNumeros = e.target.value.replace(/\D/g, "");
  
    setForm((prev) => ({
      ...prev,
      precoNota10: somenteNumeros, // salva sem pontos
    }));
  };

  // ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ Carregar usuÃƒÆ’Ã‚Â¡rio do localStorage ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬
  useEffect(() => {
    const raw = localStorage.getItem("userData");
    if (!raw) return;
    try {
      const u = JSON.parse(raw);
      const id = u.idCorretor || u.id_corretor || u.codigoCorretor || u.codigo || u.id_usuarios || "";
      const corretor = {
        id, username: u.username || "", nome: u.nome || "",
        telefone: u.telefone || "", instagram: u.instagram || "",
        descricao: u.descricao || "", email: u.email || "",
      };
      setCorretorInfo(corretor);
      if (id) {
        carregarClientesDoCorretor(id);
        carregarLeadsDoCorretor(id);
      }
    } catch (e) { console.error(e); }
  }, []);

  // ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ ImÃƒÆ’Ã‚Â³vel nÃƒÆ’Ã‚Â£o captado ÃƒÂ¢Ã¢â‚¬Â Ã¢â‚¬â„¢ imovelId = "0000" ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬
  useEffect(() => {
    if (isImovelNaoCaptado) {
      setForm(p => ({ ...p, imovelId: "0000" }));
      setEnderecoQuery(""); setImoveisSugestoes([]); setShowSugestoes(false);
    } else if (form.imovelId === "0000") {
      setForm(p => ({ ...p, imovelId: "" }));
    }
  }, [isImovelNaoCaptado]);

  // ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ Filtro de clientes ao digitar ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬
  useEffect(() => {
    const termo = normText(form.clienteNome);
    const telefone = onlyDigits(form.clienteTelefone);
    if (!termo) {
      setClientesSugestoes([]);
      setLeadsSugestoes(leadsDoCorretor.slice(0, 6));
      setClienteSelecionado(null);
      setClienteStatus("NOVO");
      return;
    }
    const filtrados = clientesDoCorretor.filter(c => normText(c.nome).includes(termo));
    setClientesSugestoes(filtrados);
    const leadsFiltrados = leadsDoCorretor.filter(lead => {
      const texto = [
        lead.cliente,
        lead.telefone,
        lead.codigo_imovel,
        lead.fonte,
        lead.contato,
      ].map(normText).join(" ");
      return texto.includes(termo);
    });
    setLeadsSugestoes(leadsFiltrados.slice(0, 8));
    const exato = clientesDoCorretor.find(c => {
      const mesmoNome = normText(c.nome) === termo;
      const mesmoTelefone = telefone && onlyDigits(c.telefone) === telefone;
      return mesmoNome || mesmoTelefone;
    });
    if (exato) setClienteStatus("EXISTENTE");
    else { setClienteStatus("NOVO"); setClienteSelecionado(null); }
  }, [form.clienteNome, form.clienteTelefone, clientesDoCorretor, leadsDoCorretor]);

  // ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ Debounce busca de imÃƒÆ’Ã‚Â³veis ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬
  useEffect(() => {
    if (isImovelNaoCaptado || !showSugestoes) return;
    const t = setTimeout(() => buscarImoveisPorEndereco(enderecoQuery), 350);
    return () => clearTimeout(t);
  }, [enderecoQuery, showSugestoes, isImovelNaoCaptado]);

  function updateField(field) {
    return e => setForm(p => ({ ...p, [field]: e.target.value }));
  }

  function setRadio(field, value) {
    return () => setForm(p => ({ ...p, [field]: value }));
  }
  const montarEnderecoImovel = (item) => {
    return [
      item?.endereco,
      item?.numero,
      item?.bairro,
      item?.cidade ? `${item.cidade}${item.uf ? `/${item.uf}` : ""}` : "",
    ]
      .filter(Boolean)
      .join(", ");
  };

  const montarTituloImovel = (item) => {
    const titulo = String(item?.titulo || "").trim();
    if (titulo) return titulo;
    const endereco = montarEnderecoImovel(item);
    return endereco || "Imovel encontrado";
  };

  const selecionarImovel = (item) => {
    const endereco = montarEnderecoImovel(item);
    const titulo = montarTituloImovel(item);
    const codigo = String(item?.codigo || "");
    const textoBusca = [codigo ? `Cod. ${codigo}` : "", titulo].filter(Boolean).join(" - ");

    setForm((prev) => ({
      ...prev,
      imovelId: codigo,
      enderecoExterno: endereco || titulo,
    }));
    setEnderecoQuery(textoBusca || endereco);
    setShowSugestoes(false);
    setImoveisSugestoes([]);
  };


  // ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ API calls ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬
  async function carregarClientesDoCorretor(idCorretor) {
    setLoadingClientes(true);
    try {
      const r = await fetch(`${BASE}/clientes_busca?id_corretor=${encodeURIComponent(idCorretor)}&q=&limit=500`);
      const d = await r.json().catch(() => ({}));
      if (r.ok && d.ok) setClientesDoCorretor(Array.isArray(d.lista) ? d.lista : []);
    } catch (e) { console.error(e); }
    finally { setLoadingClientes(false); }
  }

  async function carregarLeadsDoCorretor(idCorretor) {
    setLoadingLeads(true);
    try {
      const r = await fetch(`${BASE}/leads_busca?id_corretor=${encodeURIComponent(idCorretor)}&q=&limit=80`);
      const d = await r.json().catch(() => ({}));
      if (r.ok && d.ok) setLeadsDoCorretor(Array.isArray(d.lista) ? d.lista : []);
    } catch (e) { console.error(e); }
    finally { setLoadingLeads(false); }
  }

  function selecionarCliente(c) {
    setClienteSelecionado(c); setClienteStatus("EXISTENTE");
    setForm(p => ({ ...p, clienteNome: c.nome || "", clienteTelefone: c.telefone || "", clienteEmail: c.email || "" }));
    setShowClientesSugestoes(false); setClientesSugestoes([]); setLeadsSugestoes([]);
  }

  function selecionarLead(lead) {
    const leadTelefone = onlyDigits(lead.telefone);
    const clienteExistente = clientesDoCorretor.find(c => {
      const mesmoNome = normText(c.nome) === normText(lead.cliente);
      const mesmoTelefone = leadTelefone && onlyDigits(c.telefone) === leadTelefone;
      return mesmoNome || mesmoTelefone;
    });
    const codigo = String(lead.codigo_imovel || "").trim();

    if (clienteExistente?.id_cliente) {
      setClienteSelecionado(clienteExistente);
      setClienteStatus("EXISTENTE");
    } else {
      setClienteSelecionado(null);
      setClienteStatus("NOVO");
    }

    setForm(p => ({
      ...p,
      clienteNome: clienteExistente?.nome || lead.cliente || "",
      clienteTelefone: clienteExistente?.telefone || lead.telefone || "",
      clienteEmail: clienteExistente?.email || p.clienteEmail || "",
      imovelId: !isImovelNaoCaptado && codigo ? codigo : p.imovelId,
    }));
    if (!isImovelNaoCaptado && codigo) {
      setEnderecoQuery(["Cod. " + codigo, lead.fonte].filter(Boolean).join(" - "));
    }
    setShowClientesSugestoes(false);
    setClientesSugestoes([]);
    setLeadsSugestoes([]);
  }

  async function buscarImoveisPorEndereco(query) {
    const q = (query || "").trim();
    if (isImovelNaoCaptado || q.length < 3) { setImoveisSugestoes([]); return; }
    setLoadingImoveis(true);
    try {
      const r = await fetch(`${BASE}/imoveis_busca?endereco=${encodeURIComponent(q)}`);
      const d = await r.json().catch(() => ({}));
      if (r.ok && d.ok) setImoveisSugestoes(Array.isArray(d.lista) ? d.lista : []);
    } catch (e) { console.error(e); }
    finally { setLoadingImoveis(false); }
  }

  async function uploadArquivoObrigatorio({ idCorretor, imovelId, dataVisita }) {
    const fd = new FormData();
    fd.append("file", pdfFile);
    fd.append("idCorretor", idCorretor || "");
    fd.append("imovelId", imovelId || "");
    fd.append("dataVisita", dataVisita || "");
    const r = await fetch(`${BASE}/upload_pdf`, { method: "POST", body: fd });
    const d = await r.json().catch(() => ({}));
    if (!r.ok || !d.ok) throw new Error(d.error || "Erro ao enviar arquivo");
    return { drivePath: d.drivePath || "", driveLink: d.driveLink || "" };
  }

  async function criarClienteSeNecessario() {
    const nome     = (form.clienteNome || "").trim();
    const telefone = (form.clienteTelefone || "").trim();
    const email    = (form.clienteEmail || "").trim();
    if (!nome) throw new Error("Informe o nome do cliente.");
    if (clienteStatus === "EXISTENTE" && clienteSelecionado?.id_cliente) return clienteSelecionado.id_cliente;

    const r = await fetch(`${BASE}/clientes`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ nome, telefone, email, id_corretor: corretorInfo.id, corretor_email: corretorInfo.email || "" }),
    });
    const d = await r.json().catch(() => ({}));
    if (!r.ok || !d.ok) throw new Error(d.error || "Erro ao criar cliente");
    const novoId = d.id_cliente || null;
    const novoCliente = { id_cliente: novoId, nome, telefone, email };
    setClientesDoCorretor(prev => {
      const jaExiste = prev.some(c =>
        (c.nome||"").trim().toLowerCase() === nome.toLowerCase() &&
        (c.telefone||"").trim() === telefone &&
        (c.email||"").trim().toLowerCase() === email.toLowerCase()
      );
      if (jaExiste) return prev;
      return [...prev, novoCliente].sort((a,b) => (a.nome||"").localeCompare(b.nome||"", "pt-BR", { sensitivity:"base" }));
    });
    setClienteSelecionado(novoCliente); setClienteStatus("EXISTENTE");
    return novoId;
  }

  async function handleSubmit(e) {
    e.preventDefault();
    // ÃƒÂ°Ã…Â¸Ã…Â¡Ã‚Â¨ validaÃƒÆ’Ã‚Â§ÃƒÆ’Ã‚Â£o obrigatÃƒÆ’Ã‚Â³ria de imÃƒÆ’Ã‚Â³vel
    if (!isImovelNaoCaptado) {
    //  if (!form.imovelId || !form.imovelId.trim()) {
    //    alert("Informe o cÃƒÆ’Ã‚Â³digo do imÃƒÆ’Ã‚Â³vel.");
    //    return;
    //  }

      if (!enderecoQuery || !enderecoQuery.trim()) {
        toast("Digite um endereco de imovel!", "error");
        return;
      }
    } else {
      if (!form.enderecoExterno || !form.enderecoExterno.trim()) {
        toast("Informe o endereco do imovel.", "error");
        return;
      }
    }
    if (!corretorInfo.id) { toast("Erro: faca login novamente.", "error"); return; }
    if (!pdfFile)         { toast("Selecione uma foto ou PDF antes de enviar.", "error"); return; }
    if (!form.clienteNome.trim()) { toast("Informe o nome do cliente.", "error"); return; }
    setLoading(true);
    try {
      const idCliente = await criarClienteSeNecessario();
      const { drivePath, driveLink } = await uploadArquivoObrigatorio({
        idCorretor: corretorInfo.id, imovelId: form.imovelId, dataVisita: form.dataVisita,
      });
      const payload = {
        ...form,
        imovelId: isImovelNaoCaptado ? "0000" : form.imovelId,
        enderecoExterno: form.enderecoExterno || enderecoQuery,
        precoNota10: form.precoNota10 ? (Number(form.precoNota10) / 100) : "",
        idCorretor: corretorInfo.id, idCliente: idCliente || "",
        anexoFichaVisita: drivePath, linkImagem: driveLink,
        corretor: corretorInfo.nome || corretorInfo.username,
        corretorEmail: corretorInfo.email || "",
        telefoneCorretor: corretorInfo.telefone,
        instagramCorretor: corretorInfo.instagram,
        descricaoCorretor: corretorInfo.descricao,
        avaliacoes: {
          localizacao: Number(form.localizacao), tamanho: Number(form.tamanho),
          planta: Number(form.planta), acabamento: Number(form.acabamento),
          conservacao: Number(form.conservacao), condominio: Number(form.condominio),
          preco: Number(form.preco), notaGeral: Number(form.notaGeral),
        },
      };
      const r = await fetch(`${BASE}/visitas`, {
        method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload),
      });
      const d = await r.json().catch(() => ({}));
      if (!r.ok || !d.ok) throw new Error(d.error || "Erro ao registrar visita");
      setSuccessMessage(`Visita lancada com sucesso! ID: ${d.id_visita}`);
      setTimeout(() => setSuccessMessage(""), 2500);
      // Reset
      setForm({ imovelId:"", dataVisita: new Date().toISOString().split("T")[0], parceiroExterno:"NAO", situacaoImovel:"CAPTACAO_61", clienteNome:"", clienteTelefone:"", clienteEmail:"", proposta:"Talvez", papelVisita:"Interessado", enderecoExterno:"", parceiroNome:"", parceiroImobiliaria:"", clienteAssinanteNome:"", clienteAssinanteTelefone:"", clienteAssinanteEmail:"", assinatura:"", audioDescricaoClienteVisita:"", linkAudio:"", localizacao:10, tamanho:10, planta:10, acabamento:10, conservacao:10, condominio:10, preco:10, notaGeral:10, precoNota10:"" });
      setEnderecoQuery(""); setImoveisSugestoes([]); setShowSugestoes(false); setPdfFile(null);
      setClienteSelecionado(null); setClienteStatus("NOVO"); setClientesSugestoes([]); setLeadsSugestoes([]); setShowClientesSugestoes(false);
    } catch (err) {
      console.error(err);
      toast(err.message || "Erro inesperado. Tente novamente.", "error");
    } finally {
      setLoading(false);
    }
  }

  // ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ BotÃƒÆ’Ã‚Âµes de nota 1-10 com gradiente de cor ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬
  function renderNotaButtons(field) {
    const value = Number(form[field]);
    const legendas = { 1:"Pessimo", 2:"Muito ruim", 3:"Ruim", 4:"Regular", 5:"Medio", 6:"Razoavel", 7:"Bom", 8:"Muito bom", 9:"Otimo", 10:"Excelente" };
    return (
      <>
        <div className="nota-grid">
          {Array.from({ length: 10 }, (_, i) => i + 1).map(n => (
            <button
              key={n}
              type="button"
              data-nota={String(n)}
              className={`nota-btn${value === n ? " nota-btn-active" : ""}`}
              onClick={() => setForm(p => ({ ...p, [field]: n }))}
              aria-label={`Nota ${n}: ${legendas[n]}`}
              aria-pressed={value === n}
            >
              {n}
            </button>
          ))}
        </div>
        {value > 0 && (
          <div className="nota-legenda">
            Selecionado: <strong>{value} - {legendas[value]}</strong>
          </div>
        )}
      </>
    );
  }

  // ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ Render ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬
  return (
    <div className="visita-form-wrapper">
      {successMessage && (
        <div className="vf-success-toast" role="status" aria-live="polite">
          <div className="vf-success-check">OK</div>
          <div className="vf-success-text">{successMessage}</div>
        </div>
      )}
      <form className="visita-form" onSubmit={handleSubmit} noValidate>

        {/* CabeÃƒÆ’Ã‚Â§alho */}
        <div className="vf-header">
          <h2>Lancar Visita</h2>
          <p>Preencha os campos abaixo. Os marcados com <span style={{color:"#e1005b"}}>*</span> sao obrigatorios.</p>
        </div>

        {/* ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ SEÃƒÆ’Ã¢â‚¬Â¡ÃƒÆ’Ã†â€™O 1: Corretor ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ */}
        <div className="vf-section">
          <div className="vf-section-title">
            <Icon ch="ÃƒÂ°Ã…Â¸Ã¢â‚¬ËœÃ‚Â¤" label="corretor" /> Corretor
          </div>
          <div className="vf-group">
            <label>Voce esta logado como</label>
            <div className="vf-readonly">
              {(corretorInfo.id ? `${corretorInfo.id} - ` : "") + (corretorInfo.nome || corretorInfo.username || "Nao identificado")}
            </div>
          </div>
        </div>

        {/* ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ SEÃƒÆ’Ã¢â‚¬Â¡ÃƒÆ’Ã†â€™O 2: ImÃƒÆ’Ã‚Â³vel ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ */}
        <div className="vf-section">
          <div className="vf-section-title">
            <Icon ch="" label="imovel" /> Imovel
          </div>

          {/* SituaÃƒÆ’Ã‚Â§ÃƒÆ’Ã‚Â£o do imÃƒÆ’Ã‚Â³vel */}
          <div className="vf-group">
            <label>E captacao 61?<span className="vf-obrigatorio">*</span></label>
            <div className="vf-toggle-row">
              {[
                { val: "CAPTACAO_61", label: "Sim" },
                { val: "IMOVEL_NAO_CAPTADO", label: "Nao" },
              ].map(op => (
                <button
                  key={op.val}
                  type="button"
                  className={`vf-toggle ${op.val === "CAPTACAO_61" ? "vf-toggle-yes" : "vf-toggle-no"}${form.situacaoImovel === op.val ? " vf-toggle-active" : ""}`}
                  onClick={setRadio("situacaoImovel", op.val)}
                  aria-pressed={form.situacaoImovel === op.val}
                >
                  {op.label}
                </button>
              ))}
            </div>
          </div>

          {/* Parceiro externo */}
          <div className="vf-group">
            <label>Tem parceiro externo na visita?<span className="vf-obrigatorio">*</span></label>
            <div className="vf-toggle-row">
              <button
                type="button"
                className={`vf-toggle vf-toggle-no${form.parceiroExterno === "NAO" ? " vf-toggle-active" : ""}`}
                onClick={setRadio("parceiroExterno", "NAO")}
                aria-pressed={form.parceiroExterno === "NAO"}
              >
                Nao
              </button>
              <button
                type="button"
                className={`vf-toggle vf-toggle-yes${form.parceiroExterno === "SIM" ? " vf-toggle-active" : ""}`}
                onClick={setRadio("parceiroExterno", "SIM")}
                aria-pressed={form.parceiroExterno === "SIM"}
              >
                Sim
              </button>
            </div>
          </div>

          {/* Revisita */}
          <div className="vf-group">
            <label>É uma revisita? (imóvel já visitado antes)</label>
            <div className="vf-toggle-row">
              <button
                type="button"
                className={`vf-toggle vf-toggle-no${form.revisita === "NAO" ? " vf-toggle-active" : ""}`}
                onClick={setRadio("revisita", "NAO")}
                aria-pressed={form.revisita === "NAO"}
              >
                Nao
              </button>
              <button
                type="button"
                className={`vf-toggle vf-toggle-yes${form.revisita === "SIM" ? " vf-toggle-active" : ""}`}
                onClick={setRadio("revisita", "SIM")}
                aria-pressed={form.revisita === "SIM"}
              >
                Sim
              </button>
            </div>
          </div>

          {/* Busca de imÃƒÆ’Ã‚Â³vel ou endereÃƒÆ’Ã‚Â§o manual */}
          {!isImovelNaoCaptado ? (
            <div className="vf-group">
              <label htmlFor="buscaImovel">Digite o endereco do imovel<span className="vf-obrigatorio">*</span></label>
              <input
                id="buscaImovel"
                type="text"
                value={enderecoQuery}
                onChange={e => { setEnderecoQuery(e.target.value); setShowSugestoes(true); }}
                onFocus={() => setShowSugestoes(true)}
                placeholder="Ex: SQS 308, W3, Rua 12..."
                autoComplete="off"
              />
              {loadingImoveis && <div className="vf-hint">Buscando imoveis...</div>}
              {showSugestoes && imoveisSugestoes.length > 0 && (
                <div className="vf-sugestoes">
                  {imoveisSugestoes.map(it => (
                    <button
                      type="button"
                      key={`${it.codigo}-${it.finalidade||""}`}
                      className="vf-sugestao-item vf-sugestao-imovel"
                      onClick={() => selecionarImovel(it)}
                    >
                      <div className="vf-sugestao-row">
                        <span className="vf-sugestao-codigo">{it.codigo ? `Cod. ${it.codigo}` : "Sem codigo"}</span>
                        {it.finalidade && <span className="vf-sugestao-finalidade">{it.finalidade}</span>}
                      </div>
                      <div className="vf-sugestao-title">{montarTituloImovel(it)}</div>
                      <div className="vf-sugestao-sub">{montarEnderecoImovel(it) || "Endereco nao informado"}</div>
                    </button>
                  ))}
                </div>
              )}
            </div>
          ) : (
            <div className="vf-group">
              <label htmlFor="enderecoManual">Endereco do imovel<span className="vf-obrigatorio">*</span></label>
              <input
                id="enderecoManual"
                type="text"
                value={form.enderecoExterno}
                onChange={updateField("enderecoExterno")}
                placeholder="Digite o endereco completo"
                required
              />
            </div>
          )}

          {!isImovelNaoCaptado && (
            <div className="vf-group">
              <label htmlFor="imovelCodigo">Codigo do imovel<span className="vf-obrigatorio">*</span></label>
              <input
                id="imovelCodigo"
                type="text"
                value={form.imovelId}
                onChange={updateField("imovelId")}
                placeholder="Preenchido ao selecionar acima"
                required
              />
            </div>
          )}

          {/* Data */}
          <div className="vf-group">
            <label htmlFor="dataVisita">Data da visita<span className="vf-obrigatorio">*</span></label>
            <input
              id="dataVisita"
              type="date"
              value={form.dataVisita}
              onChange={updateField("dataVisita")}
              required
            />
          </div>
        </div>

        {/* ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ SEÃƒÆ’Ã¢â‚¬Â¡ÃƒÆ’Ã†â€™O 3: Cliente ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ */}
        <div className="vf-section">
          <div className="vf-section-title">
            <Icon ch="ÃƒÂ°Ã…Â¸Ã‚Â§Ã¢â‚¬Ëœ" label="cliente" /> Cliente
          </div>

          <div className="vf-group">
            <label htmlFor="clienteNome">Nome do cliente<span className="vf-obrigatorio">*</span></label>
            <input
              id="clienteNome"
              type="text"
              value={form.clienteNome}
              onChange={e => {
                const nome = e.target.value;
                setForm(p => ({ ...p, clienteNome: nome, ...(nome.trim() ? {} : { clienteTelefone:"", clienteEmail:"" }) }));
                setShowClientesSugestoes(true); setClienteSelecionado(null);
              }}
              onFocus={() => setShowClientesSugestoes(true)}
              placeholder="Nome completo do cliente"
              autoComplete="off"
              required
            />
            {(loadingClientes || loadingLeads) && <div className="vf-hint">Carregando clientes e leads...</div>}
            {!!form.clienteNome && (
              <span className={`vf-badge ${clienteStatus === "EXISTENTE" ? "vf-badge--existente" : "vf-badge--novo"}`}>
                {clienteStatus === "EXISTENTE" ? "Cliente ja cadastrado" : "Novo cliente"}
              </span>
            )}
            {showClientesSugestoes && clientesSugestoes.length > 0 && (
              <div className="vf-sugestoes">
                {clientesSugestoes.map(c => (
                  <button type="button" key={c.id_cliente} className="vf-sugestao-item" onClick={() => selecionarCliente(c)}>
                    <div className="vf-sugestao-title">{c.nome}</div>
                    <div className="vf-sugestao-sub">{c.telefone || "Sem telefone"}{c.email ? ` - ${c.email}` : ""}</div>
                  </button>
                ))}
              </div>
            )}
            {showClientesSugestoes && leadsSugestoes.length > 0 && (
              <div className="vf-sugestoes vf-sugestoes-leads">
                <div className="vf-sugestoes-label">Leads do seu atendimento</div>
                {leadsSugestoes.map(lead => (
                  <button type="button" key={`lead-${lead.id}`} className="vf-sugestao-item vf-sugestao-lead" onClick={() => selecionarLead(lead)}>
                    <div className="vf-sugestao-title">{lead.cliente || "Lead sem nome"}</div>
                    <div className="vf-sugestao-sub">
                      {[
                        lead.telefone || "Sem telefone",
                        lead.codigo_imovel ? `Cod. ${lead.codigo_imovel}` : "",
                        lead.fonte || "",
                        lead.data || "",
                      ].filter(Boolean).join(" - ")}
                    </div>
                  </button>
                ))}
              </div>
            )}
          </div>

          <div className="vf-group">
            <label htmlFor="clienteTelefone">
              Telefone do cliente
              <span style={{fontWeight:400, color:"#71717a", fontSize:"0.88rem"}}> (opcional)</span>
            </label>
            <input
              id="clienteTelefone"
              type="tel"
              value={form.clienteTelefone}
              onChange={updateField("clienteTelefone")}
              placeholder="(00) 00000-0000"
            />
          </div>

          <div className="vf-group">
            <label htmlFor="clienteEmail">
              E-mail do cliente
              <span style={{fontWeight:400, color:"#71717a", fontSize:"0.88rem"}}> (opcional)</span>
            </label>
            <input
              id="clienteEmail"
              type="email"
              value={form.clienteEmail}
              onChange={updateField("clienteEmail")}
              placeholder="email@exemplo.com"
            />
          </div>
        </div>

        {/* ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ SEÃƒÆ’Ã¢â‚¬Â¡ÃƒÆ’Ã†â€™O 4: AvaliaÃƒÆ’Ã‚Â§ÃƒÆ’Ã‚Âµes ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ */}
        <div className="vf-section">
          <div className="vf-section-title">
            <Icon ch="" label="avaliacoes" /> Avaliacoes do Imovel
          </div>
          <div className="vf-hint" style={{marginBottom:14}}>
            Toque no numero para dar a nota. 1 = pior, 10 = melhor.
          </div>

          {[
            { field:"localizacao",  label:"Localizacao" },
            { field:"tamanho",      label:"Tamanho" },
            { field:"planta",       label:"Planta do imovel" },
            { field:"acabamento",   label:"Qualidade do acabamento" },
            { field:"conservacao",  label:"Estado de conservacao" },
            { field:"condominio",   label:"Condominio e area comum" },
            { field:"preco",        label:"Preco" },
            { field:"notaGeral",    label:"Nota geral" },
          ].map(({ field, label }) => (
            <div className="vf-group" key={field}>
              <label>{label}</label>
              {renderNotaButtons(field)}
            </div>
          ))}

          <div className="vf-group">
            <label htmlFor="precoNota10">
              Qual seria o preco ideal (nota 10)?{" "}
              <span style={{ fontWeight: 400, color: "#71717a", fontSize: "0.88rem" }}>
                (R$, opcional)
              </span>
            </label>

            <input
              id="precoNota10"
              type="text"
              inputMode="numeric"
              value={formatarMoedaBR(form.precoNota10)}
              onChange={handlePrecoNota10Change}
              placeholder="Ex: 450.000,00"
            />
          </div>
        </div>

        {/* ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ SEÃƒÆ’Ã¢â‚¬Â¡ÃƒÆ’Ã†â€™O 5: Proposta ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ */}
        <div className="vf-section">
          <div className="vf-section-title">
            <Icon ch="ÃƒÂ°Ã…Â¸Ã¢â‚¬Å“Ã¢â‚¬Â¹" label="proposta" /> Proposta
          </div>
          <div className="vf-group">
            <label>O cliente vai fazer proposta?<span className="vf-obrigatorio">*</span></label>
            <div className="vf-toggle-row">
              {[
                { val:"Sim",    cls:"vf-toggle-yes", icon:"" },
                { val:"Nao",    cls:"vf-toggle-no",  icon:"" },
                { val:"Talvez", cls:"",               icon:"?" },
              ].map(op => (
                <button
                  key={op.val}
                  type="button"
                  className={`vf-toggle ${op.cls}${form.proposta === op.val ? " vf-toggle-active" : ""}`}
                  onClick={setRadio("proposta", op.val)}
                  aria-pressed={form.proposta === op.val}
                >
                  {op.icon ? `${op.icon} ` : ""}{op.val}
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ SEÃƒÆ’Ã¢â‚¬Â¡ÃƒÆ’Ã†â€™O 6: Foto / PDF ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ */}
        <div className="vf-section">
          <div className="vf-section-title">
            <Icon ch="ÃƒÂ°Ã…Â¸Ã¢â‚¬Å“Ã‚Â¸" label="foto" /> Foto ou PDF
          </div>
          <div className="vf-group">
            <label>Tire uma foto ou anexe o PDF<span className="vf-obrigatorio">*</span></label>
            <label className={`vf-upload-label${pdfFile ? " has-file" : ""}`}>
              <span className="vf-upload-icon">{pdfFile ? "OK" : ""}</span>
              <span>
                {pdfFile
                  ? `Arquivo: ${pdfFile.name}`
                  : "Toque aqui para tirar foto ou escolher arquivo"}
              </span>
              <input
                type="file"
                className="vf-upload-input"
                accept="image/*,application/pdf"
                required
                onChange={e => setPdfFile(e.target.files?.[0] || null)}
              />
            </label>
            {!pdfFile && (
              <div className="vf-hint">Obrigatorio: anexe a ficha assinada pelo cliente.</div>
            )}
          </div>
        </div>

        {/* ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ BotÃƒÆ’Ã‚Â£o final ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ÃƒÂ¢Ã¢â‚¬ÂÃ¢â€šÂ¬ */}
        <button className="vf-submit" type="submit" disabled={loading}>
          {loading ? "Enviando visita..." : "Lancar Visita"}
        </button>

      </form>
    </div>
  );
}
